import { defineType } from "sanity";

import { multilingualStringPreview } from "../base/multilingualArrayString";

export default defineType({
  name: "slide",
  title: "Slide",
  type: "object",
  preview: {
    select: {
      media: "imageWithCaption",
      title: "imageWithCaption.caption"
    },
    prepare({ title, media }) {
      return { title: multilingualStringPreview(title), media };
    }
  },
  fields: [
    {
      name: "imageWithCaption",
      title: "Image",
      type: "imageWithCaption"
    }
  ]
});
